<!--
 * @Author: your name
 * @Date: 2021-05-24 10:45:48
 * @LastEditTime: 2021-08-13 11:26:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \rightcloud-console\src\views\426.vue
-->
<template>
    <div class="error426">
        <portal-header :transparent='false'
                       :isShowUser='false'></portal-header>
        <div class="title">
            {{announcementData.noticeTitle}}
        </div>
        <div class="content">
            <div class="detail">
                <div class="titbg">
                    <img src="@/assets/images/upgradeBg.jpg"
                         alt="">
                    <p>{{announcementData.noticeTypeName}}</p>
                </div>
                <div v-if="announcementData.noticeContent"
                     class="announcement-details-content ql-editor"
                     v-html="announcementData.noticeContent">
                </div>
                <div v-else
                     class="no-data">{{$t('暂无数据')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import portalHeader from '@c/portal/header'
import API from '@/service/api.js'
export default {
    name: 'Error426',
    components: {
        portalHeader
    },
    data () {
        return {
            announcementData: {}
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.axios.get(this.urlFormat(API.GET_NOTICE_UPGRADE_INFO, true)).then(res => {
                this.announcementData = res
            })
        }
    }
}
</script>
<style lang="less" scoped>
.error426 {
    background: #f5f6f7;
    padding-top: 55px;
    height: 100%;
    .no-data {
        text-align: center;
        color: #808080;
        padding: 50px 0;
    }
    .content {
        // font-size: 14px;
        line-height: 25px;
        color: #666;
        width: 1000px;
        margin: 15px auto 15px auto;
        width: 1000px;
        background: #fff;
        padding: 50px 15px 15px 15px;
        height: calc(~'100% - 75px');
        // overflow-y: auto;
        h4 {
            padding-top: 15px;
        }
        .announcement-details-content {
            padding: 20px 0 70px 0;
        }
    }
    .detail {
        width: 600px;
        margin: 0 auto 0 auto;
        overflow: hidden;
    }
    .titbg {
        position: relative;
        p {
            line-height: 70px;
            text-align: center;
            font-size: 24px;
            position: absolute;
            left: 0px;
            top: 0px;
            width: 100%;
            color: #fff;
        }
    }
    .title {
        width: 1000px;
        height: 50px;
        padding-left: 15px;
        line-height: 50px;
        margin: 0 auto;
        margin-bottom: 15px;
        background: #fff;
        font-weight: 600;
        font-size: 14px;
    }
}
</style>
<style lang="less">
@import './console/announcement/components/style.css';
</style>
